"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductScope = isProductScope;
const utilities_1 = require("./utilities");
function isProductScope(v) {
    if (v === null || typeof v === 'string') {
        return true;
    }
    return (0, utilities_1.isArrayOf)(v, (e) => e === null || typeof v === 'string');
}
